/**
 * @fileoverview GET handler for the "/engagement/segments/segment_territories" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementSegmentsSegmentTerritories } from "./constants";
import type {
  EngagementSegmentsSegmentTerritoriesParams,
  EngagementSegmentsSegmentTerritoriesResult,
} from "./types";

export const getEngagementSegmentsSegmentTerritories = reactQueryFetcherAdapter(
  engagementSegmentsSegmentTerritories,
  (
    signal: AbortSignal,
    { appGroupId }: EngagementSegmentsSegmentTerritoriesParams
  ): Promise<EngagementSegmentsSegmentTerritoriesResult> => {
    return fetch(
      "/engagement/segments/segment_territories",
      "GET",
      {
        app_group_id: appGroupId,
      },
      { signal }
    );
  }
);
